export const OPEN_REWARD_DISTRIBUTION = "OPEN_REWARD_DISTRIBUTION";

export const ADD_REWARD_DISTRIBUTION = "ADD_REWARD_DISTRIBUTION";

export const GET_REWARD_UNIQUEID = "GET_REWARD_UNIQUEID";

// OPEN DIALOG

export const OPEN_DIALOGUE = "OPEN_DIALOGUE";

// CLOSE DIALOG
export const CLOSE_DIALOGUE = "CLOSE_DIALOGUE";
export const GET_REWARD = "GET_REWARD";
export const GET_REWARD_CONFIG = "GET_REWARD_CONFIG";
